module.exports = __webpack_public_path__ + "static/media/JP.41558bfc.svg";